import { ACTION_TYPE, fetchJson } from '../../store/actionCreatorsHelpers';
import { updateCollaborationAppsHierarchy } from '../common/appStatusActionCreators';
import { CollaborationAppsPrioritizationData, Editor } from '../common/interfaces';

export function fetchEditors() {
    return {
        type: ACTION_TYPE.REQUEST_EDITORS,
        payload: fetchJson('api/editors'),
    };
}

export function fetchEditorsFake() {
    return {
        type: ACTION_TYPE.REQUEST_EDITORS_FAKE_PROTECT_SESSION,
    };
}

export function updateEditorsOrder(editorsOrder: Editor[]) {
    return {
        type: ACTION_TYPE.UPDATE_EDITORS_ORDER,
        payload: {
            editorsOrder,
        },
    };
}

export function saveNewCollaborationAppsHierarchy(payload: CollaborationAppsPrioritizationData) {
    return {
        type: ACTION_TYPE.SAVE_NEW_COLLABORATION_APPS_HIERARCHY,
        payload: updateCollaborationAppsHierarchy(payload),
    };
}
